(function () {
  'use strict';

  function initializeStickyAddToCart(root) {
    var sectionId = root.getAttribute('data-section-id');
    var nativeButton = document.getElementById('AddToCart-' + sectionId);
    var stickyButton = root.querySelector('[data-sticky-atc-button]');
    var stickyLabel = root.querySelector('[data-sticky-atc-label]');
    if (!nativeButton || !stickyButton || !stickyLabel || !('IntersectionObserver' in window)) return;

    function synchronizeBottomClearance() {
      var anyVisible = !!document.querySelector('[data-sticky-atc]:not([hidden])');
      document.body.classList.toggle('nat-sticky-atc-open', anyVisible);
    }

    function synchronize() {
      stickyButton.disabled = nativeButton.disabled;
      stickyLabel.textContent = (nativeButton.textContent || '').trim();
      stickyButton.setAttribute('aria-label', stickyLabel.textContent || 'Add to cart');
      var bounds = nativeButton.getBoundingClientRect();
      var inViewport = bounds.bottom > 0 && bounds.top < window.innerHeight;
      var shouldHide = inViewport || nativeButton.disabled;
      if (shouldHide && !root.hidden && root.contains(document.activeElement)) {
        if (!nativeButton.disabled && inViewport) nativeButton.focus({ preventScroll: true });
        else stickyButton.blur();
      }
      root.hidden = shouldHide;
      synchronizeBottomClearance();
    }

    var observer = new IntersectionObserver(function (entries) {
      synchronize();
    }, { threshold: 0.1 });

    observer.observe(nativeButton);
    new MutationObserver(synchronize).observe(nativeButton, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true
    });

    stickyButton.addEventListener('click', function () {
      synchronize();
      if (!nativeButton.disabled) nativeButton.click();
    });
  }

  function initialize() {
    document.querySelectorAll('[data-sticky-atc]').forEach(initializeStickyAddToCart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
}());
